import React from "react";

const PropertyConfirmModal = ({ isOpen, onYes, onNo }) => {
  if (!isOpen) return null;

  return (
    <div
      className="modal"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 10,
      }}
    >
      <div
        className="modal-content"
        style={{
          background: "white",
          padding: "30px",
          borderRadius: "8px",
          textAlign: "center",
          maxWidth: "500px",
        }}
      >
        <h2 style={{ margin: "10px 0 20px 0", fontSize: "20px" }}>
          Property Confirmation
        </h2>
        <p style={{ fontSize: "16px", marginBottom: "30px", fontWeight: "500" }}>
          Do you have a Property related to this request?
        </p>
        <div style={{ display: "flex", gap: "15px", justifyContent: "center" }}>
          <button
            onClick={onYes}
            style={{
              padding: "10px 30px",
              border: "none",
              background: "#07b1b0",
              color: "white",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "16px",
              fontWeight: "500",
            }}
          >
            Yes
          </button>
          <button
            onClick={onNo}
            style={{
              padding: "10px 30px",
              border: "1px solid #ccc",
              background: "white",
              color: "#333",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "16px",
              fontWeight: "500",
            }}
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default PropertyConfirmModal;
